import { compose } from "redux";
import { withDailyTexts } from "../../store/dailytexts";
import ResetSelect from "./Reset";

export default compose(withDailyTexts)(ResetSelect);



// WEBPACK FOOTER //
// ./src/components/ResetSelect/index.js